// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"JobInstanceCard_imageWrapper__Ot5PW","image":"JobInstanceCard_image__Evlo8"};